import { ComponentsOverrides, Theme } from "@mui/material";
import { ciCustomColors } from "@/theme/colors";

type MuiTooltip = {
  styleOverrides: ComponentsOverrides<Theme>["MuiTooltip"];
};

const muiTooltip: MuiTooltip = {
  styleOverrides: {
    tooltip: {
      fontSize: "13px",
      lineHeight: 1.4,
      backgroundColor: ciCustomColors.dark[100],
    },
    arrow: {
      color: ciCustomColors.dark[100],
    },
  },
};

export default muiTooltip;
